import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { plansAPI } from 'services/transactionService';

const PaymentCancel = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const sessionId = params.get('session_id');
    if (sessionId) {
      plansAPI.afterCheckout(sessionId)
        .then(response => {
          if (response?.data?.redirect_url) {
            window.location.href = response.data.redirect_url;
          }
        })
        .catch(() => {
          // Optionally handle error
        });
    }
  }, [location]);

  return (
    <div>
      <h1>Processing cancellation...</h1>
    </div>
  );
};

export default PaymentCancel; 
